__turbopack_context__.v({
  "appShellBreadcrumb": "AppShell-module__onZTIa__appShellBreadcrumb",
  "appShellBreadcrumbBackButton": "AppShell-module__onZTIa__appShellBreadcrumbBackButton",
  "appShellBreadcrumbBackButtonIcon": "AppShell-module__onZTIa__appShellBreadcrumbBackButtonIcon",
  "appShellBreadcrumbBadge": "AppShell-module__onZTIa__appShellBreadcrumbBadge",
  "appShellBreadcrumbCurrent": "AppShell-module__onZTIa__appShellBreadcrumbCurrent",
  "appShellBreadcrumbIcon": "AppShell-module__onZTIa__appShellBreadcrumbIcon",
  "appShellBreadcrumbItem": "AppShell-module__onZTIa__appShellBreadcrumbItem",
  "appShellBreadcrumbLabel": "AppShell-module__onZTIa__appShellBreadcrumbLabel",
  "appShellBreadcrumbLink": "AppShell-module__onZTIa__appShellBreadcrumbLink",
  "appShellBreadcrumbList": "AppShell-module__onZTIa__appShellBreadcrumbList",
  "appShellBreadcrumbSeparator": "AppShell-module__onZTIa__appShellBreadcrumbSeparator",
  "appShellContentMaxWidth": "AppShell-module__onZTIa__appShellContentMaxWidth",
  "appShellDesktopAside": "AppShell-module__onZTIa__appShellDesktopAside",
  "appShellDesktopAsideCollapsed": "AppShell-module__onZTIa__appShellDesktopAsideCollapsed",
  "appShellDesktopAsideExpanded": "AppShell-module__onZTIa__appShellDesktopAsideExpanded",
  "appShellDesktopLayout": "AppShell-module__onZTIa__appShellDesktopLayout",
  "appShellLoginButton": "AppShell-module__onZTIa__appShellLoginButton",
  "appShellMain": "AppShell-module__onZTIa__appShellMain",
  "appShellMainColumn": "AppShell-module__onZTIa__appShellMainColumn",
  "appShellMobileFooter": "AppShell-module__onZTIa__appShellMobileFooter",
  "appShellMobilePanel": "AppShell-module__onZTIa__appShellMobilePanel",
  "appShellMobilePanelInner": "AppShell-module__onZTIa__appShellMobilePanelInner",
  "appShellMobileToggle": "AppShell-module__onZTIa__appShellMobileToggle",
  "appShellMobileToggleIcon": "AppShell-module__onZTIa__appShellMobileToggleIcon",
  "appShellPageWrapper": "AppShell-module__onZTIa__appShellPageWrapper",
  "appShellRoleBadge": "AppShell-module__onZTIa__appShellRoleBadge",
  "appShellRoot": "AppShell-module__onZTIa__appShellRoot",
  "appShellSidePanel": "AppShell-module__onZTIa__appShellSidePanel",
  "appShellSidePanelBody": "AppShell-module__onZTIa__appShellSidePanelBody",
  "appShellSidePanelButton": "AppShell-module__onZTIa__appShellSidePanelButton",
  "appShellSidePanelButtonActive": "AppShell-module__onZTIa__appShellSidePanelButtonActive",
  "appShellSidePanelButtonWrap": "AppShell-module__onZTIa__appShellSidePanelButtonWrap",
  "appShellSidePanelClose": "AppShell-module__onZTIa__appShellSidePanelClose",
  "appShellSidePanelContent": "AppShell-module__onZTIa__appShellSidePanelContent",
  "appShellSidePanelHeader": "AppShell-module__onZTIa__appShellSidePanelHeader",
  "appShellSidePanelInner": "AppShell-module__onZTIa__appShellSidePanelInner",
  "appShellSidePanelRail": "AppShell-module__onZTIa__appShellSidePanelRail",
  "appShellSidePanelScrim": "AppShell-module__onZTIa__appShellSidePanelScrim",
  "appShellSidePanelZoomSlider": "AppShell-module__onZTIa__appShellSidePanelZoomSlider",
  "appShellSidebar": "AppShell-module__onZTIa__appShellSidebar",
  "appShellSidebarFooterPad": "AppShell-module__onZTIa__appShellSidebarFooterPad",
  "appShellSidebarFooterPadCollapsed": "AppShell-module__onZTIa__appShellSidebarFooterPadCollapsed",
  "appShellSidebarFooterPadExpanded": "AppShell-module__onZTIa__appShellSidebarFooterPadExpanded",
  "appShellSidebarHeaderPad": "AppShell-module__onZTIa__appShellSidebarHeaderPad",
  "appShellSidebarHeaderPadCollapsed": "AppShell-module__onZTIa__appShellSidebarHeaderPadCollapsed",
  "appShellSidebarHeaderPadExpanded": "AppShell-module__onZTIa__appShellSidebarHeaderPadExpanded",
  "appShellSidebarTop": "AppShell-module__onZTIa__appShellSidebarTop",
  "appShellSkeletonPulse": "AppShell-module__onZTIa__appShellSkeletonPulse",
  "appShellStatusPill": "AppShell-module__onZTIa__appShellStatusPill",
  "appShellTopbar": "AppShell-module__onZTIa__appShellTopbar",
  "appShellTopbarActions": "AppShell-module__onZTIa__appShellTopbarActions",
  "appShellTopbarInner": "AppShell-module__onZTIa__appShellTopbarInner",
  "appShellTopbarLeft": "AppShell-module__onZTIa__appShellTopbarLeft",
  "appShellTopbarRight": "AppShell-module__onZTIa__appShellTopbarRight",
  "appShellTopbarSkeleton": "AppShell-module__onZTIa__appShellTopbarSkeleton",
});
